import { useRef } from 'react';
import useEffectOnce from './use-effect-once.esm.js';

/* eslint-disable @typescript-eslint/no-explicit-any */

var useUnmount = function useUnmount(fn) {
  var fnRef = useRef(fn);

  // update the ref each render so if it change the newest callback will be invoked
  fnRef.current = fn;
  useEffectOnce(function () {
    return function () {
      return fnRef.current();
    };
  });
};

export default useUnmount;
//# sourceMappingURL=use-unmount.esm.js.map
